export const RESPONSE_TYPE = 'code';
export const CODE_CHALLENGE_METHOD = 'S256';
export const GRANT_TYPE = 'authorization_code';